<template>
  <v-container fluid v-if="order != null">
    <vue-headful :title="`Order Detail - Halalize for Business`" />
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/commerce/orders/live?ref=detail' }"
        >ออเดอร์วันนี้</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: '/view/shop/' + order.shop.ref_no }">{{
        order.shop.name
      }}</el-breadcrumb-item>
      <el-breadcrumb-item
        >{{ order.order_reference }}-{{
          order.order_id | numFormat("00000")
        }}</el-breadcrumb-item
      >
    </el-breadcrumb>
    <v-layout row wrap class="mt-4">
      <v-flex xs12 sm12 md8>
        <div class="grid-content bg-purple">
          <el-card class="box-card">
            <section class="px-3">
              <div v-if="order.status != 'cancelled'">
                <ul class="progressbar" v-if="order.order_type == 'commerce'">
                  <li :class="{ active: steps[0] == 1 }">สั่งซื้อ</li>
                  <li :class="{ active: steps[1] == 1 }">ชำระเงิน</li>
                  <li :class="{ active: steps[2] == 1 }">ยืนยันออเดอร์</li>
                  <li
                    :class="{
                      active: steps[4] == 1,
                      'active-warning': [
                        'cooking',
                        'ready-to-go',
                        'delivering',
                        'processing',
                      ].includes(order.status),
                    }"
                  >
                    <span v-if="order.status == 'cooking'"
                      >กำลังแพ็คสินค้า</span
                    >
                    <span v-else-if="order.status == 'ready-to-go'"
                      >พร้อมจัดส่ง</span
                    >
                    <span
                      v-else-if="
                        order.status == 'delivering' ||
                          order.status == 'completed'
                      "
                      >กำลังจัดส่ง</span
                    >
                    <span v-else>กำลังดำเนินการ</span>
                  </li>
                  <li :class="{ active: steps[5] == 1 }">จัดส่งแล้ว</li>
                </ul>

                <div style="clear: both" class="pb-3"></div>
                <v-divider></v-divider>
              </div>
              <div
                v-else-if="order.status == 'cancelled'"
                class="pa-1 text-center white--text grey"
              >
                ยกเลิกแล้ว
              </div>
              <div v-else class="pa-1 text-center white--text orange">
                {{ order.status }}
              </div>

              <v-row>
                <v-col :cols="12" :sm="6" :md="6"></v-col>
                <v-col :cols="12" :sm="6" :md="6" class="text-left">
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>หมายเลขออเดอร์ :</strong>
                    </el-col>
                    <el-col :span="12" class="text-right"
                      >{{ order.order_reference }}-{{
                        order.order_id | numFormat("00000")
                      }}</el-col
                    >
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>สร้างเมื่อ :</strong>
                    </el-col>
                    <el-col :span="12" class="text-right">{{
                      order.created_at | moment("DD/MM/YYYY HH:mm")
                    }}</el-col>
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>ประเภทการสั่งซื้อ :</strong>
                    </el-col>
                    <el-col :span="12" class="text-right">
                      <div v-if="order.order_type == 'pickup'">
                        <i class="fas fa-shopping-bag"></i> รับเองที่ร้าน
                      </div>
                      <div v-if="order.order_type == 'delivery'">
                        <i class="fas fa-motorcycle"></i> เดลิเวอรี่
                      </div>
                      <div v-if="order.order_type == 'commerce'">
                        <i class="fas fa-shopping-cart"></i> อีคอมเมิร์ซ
                      </div>
                      <div v-if="order.order_type == 'coupon'">
                        <i class="fas fa-ticket-alt"></i> คูปอง/วอยเชอร์โค้ด
                      </div>
                      <div
                        v-if="
                          order.order_type == 'dinein' ||
                            order.order_type == 'dinein-buffet'
                        "
                      >
                        <i class="fas fa-chair"></i> นั่งทานที่ร้าน
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>การชำระเงิน :</strong>
                    </el-col>
                    <el-col :span="12" class="text-right">
                      <div v-if="order.payment_type == 'transfer'">โอนเงิน</div>
                      <div v-if="order.payment_type == 'cash'">ชำระเงินสด</div>
                      <div v-if="order.payment_type == 'qr'">พร้อมเพย์</div>
                      <div v-if="order.payment_type == 'creditcard'">
                        บัตรเครดิต
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>ช่องทางการขาย :</strong>
                    </el-col>
                    <el-col :span="12" class="text-right">
                      <div v-if="order.order_channel == 'liff'">
                        Line Official Account
                      </div>
                      <div v-else>{{ order.order_channel }}</div>
                    </el-col>
                  </el-row>
                </v-col>
              </v-row>
            </section>
            <v-divider></v-divider>

            <v-row row wrap>
              <v-col :cols="12" :xs="12" :sm="6" style="line-height: 28px">
                <section class="pa-3" v-if="order.order_type == 'delivery'">
                  <h2 class="subtitle mb-3">ข้อมูลการจัดส่ง</h2>
                  <div class="mt-0">
                    <strong class="my-label">เส้นทาง :</strong>
                    <v-row class="mt-0">
                      <v-col :cols="12" :sm="12" :md="12">
                        <ul
                          class="my-progress large"
                          v-if="order.order_type == 'delivery'"
                        >
                          <li class="progress__item progress__item--completed">
                            <span class="progress__title">{{
                              order.shop.name
                            }}</span>
                            <!-- <span class="progress__info">{{order.shop.formatted_address}}</span> -->
                          </li>
                          <li class="progress__item progress__item--active">
                            <p class="progress__title">
                              <a :href="gg_url" target="_blank">
                                <el-tooltip
                                  v-if="
                                    order.delivery_info_json.whereTo.address
                                      .text
                                  "
                                  class="item"
                                  effect="dark"
                                  :content="
                                    order.delivery_info_json.whereTo.address
                                      .text
                                  "
                                  placement="top-start"
                                >
                                  <span>{{
                                    order.delivery_info_json.whereTo.address
                                      .text
                                  }}</span>
                                </el-tooltip>
                                <el-tooltip
                                  v-else
                                  class="item"
                                  effect="dark"
                                  :content="
                                    order.delivery_info_json.whereTo.address
                                  "
                                  placement="top-start"
                                >
                                  <span>{{
                                    order.delivery_info_json.whereTo.address
                                  }}</span>
                                </el-tooltip>
                              </a>
                            </p>
                          </li>
                        </ul>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="mt-0">
                    <strong class="my-label">ระยะทาง :</strong>
                    {{ (order.distance / 1000) | numFormat("0.00") }} km
                  </div>
                  <div class="mt-1">
                    <strong class="my-label">เวลาจัดส่ง :</strong>
                    {{ order.datetime_received | moment("DD/MM/YYYY HH:mm") }}
                    <el-tag
                      v-if="order.cluster_id != null"
                      size="mini"
                      type="info"
                      class="ml-1"
                      >รอบส่ง
                      {{
                        order.shop.cluster_json.find(
                          (x) => x.id == order.cluster_id
                        ).delivery
                      }}</el-tag
                    >
                  </div>
                </section>
                <section class="pa-3" v-if="order.order_type == 'pickup'">
                  <h2 class="subtitle mb-3">รับอาหารที่ร้าน</h2>
                  <div class="mt-4">
                    <strong class="my-label">สถานที่รับอาหาร :</strong>
                    {{ order.shop.name }}
                    <p>{{ order.shop.formatted_address }}</p>
                  </div>
                  <div class="mt-4">
                    <strong class="my-label">เวลารับอาหาร :</strong>
                    {{ order.datetime_received | moment("DD/MM/YYYY HH:mm") }}
                  </div>
                </section>
                <section class="pa-3">
                  <h2 class="subtitle mb-0">หมายเหตุ</h2>
                  <div class="px-0 mt-3 mb-3">
                    <template
                      v-if="
                        order.remark_public != '' && order.remark_public != null
                      "
                      >{{ order.remark_public }}</template
                    >
                    <template v-else
                      >ไม่มีข้อมูล</template
                    >
                  </div>
                </section>
                <section class="pa-3">
                  <h2 class="subtitle mb-3">ข้อมูลจัดส่ง</h2>
                  <v-row>
                    <v-col :cols="12">
                      <strong class="my-label">ส่งที่ :</strong>
                      <div style="font-size:1.1rem" class="font-weight-bold">
                        {{ order.user_address.place_detail.address }}
                        {{ order.user_address.place_detail.sub_district }}
                        {{ order.user_address.place_detail.district }}
                        {{ order.user_address.place_detail.province }}
                        {{ order.user_address.place_detail.postcode }}
                      </div>
                    </v-col>
                  </v-row>
                </section>
              </v-col>
              <v-col :cols="12" :xs="12" :sm="6">
                <section class="pa-3">
                  <h2 class="subtitle mb-3">ข้อมูลลูกค้า</h2>
                  <v-row>
                    <v-col :cols="5">
                      <strong class="my-label">ชื่อ :</strong>
                    </v-col>
                    <v-col :cols="15" class="text-right">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="recipient.name"
                        placement="top-start"
                      >
                        <span class="line-1-elipsis">{{ recipient.name }}</span>
                      </el-tooltip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col :cols="5">
                      <strong class="my-label">เบอร์โทร :</strong>
                    </v-col>
                    <v-col :cols="15" class="text-right">{{
                      recipient.mobile
                    }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col :cols="5">
                      <strong class="my-label">อีเมล :</strong>
                    </v-col>
                    <v-col :cols="7" class="text-right">ไม่ระบุ</v-col>
                  </v-row>
                  <v-row>
                    <v-col :cols="5">
                      <strong class="my-label">Line User :</strong>
                    </v-col>
                    <v-col :cols="7" class="text-right">ไม่ระบุ</v-col>
                  </v-row>
                </section>
              </v-col>
            </v-row>
            <v-alert
              dense
              border="left"
              color="indigo"
              dark
              v-if="order.tracking_number != null"
            >
              จัดส่งโดย
              <span v-if="order.courier == 'self_driver'">เนื้อแท้</span>
              <span v-if="order.courier == 'nim_express'">Nim Express</span>
              <span v-if="order.courier == 'inter_express'">Inter Express</span>
              <span v-if="order.courier == 'scg_express'">SCG Express</span>
              หมายเลขติดตามคือ {{ order.tracking_number }}
            </v-alert>

            <v-divider></v-divider>
            <section class="px-3 py-6">
              <h2 class="subtitle mb-3">รายการสั่งซื้อ</h2>
              <template v-if="order.order_basket.product_list.length > 0">
                <div
                  v-for="(item, index) in order.order_basket.product_list"
                  v-bind:key="index"
                >
                  <el-row
                    :gutter="10"
                    v-if="item.quantity > 0"
                    class="px-3 pt-5"
                    style="border-bottom: 1px solid #eee; min-height: 90px"
                  >
                    <el-col :span="2" class="mb-3">
                      <strong>{{ item.quantity }} x</strong>
                    </el-col>
                    <el-col :span="17" class="mb-3">
                      <v-lazy-image class="product-img" :src="item.image" />

                      <strong>{{ item.name }}</strong>
                      <p class="grey--text">{{ item.excerpt }}</p>
                      <div
                        style="padding-left: 70px"
                        v-if="item.modifiers != null"
                      >
                        <div
                          class="modifiers"
                          style="padding-left: 20px"
                          v-for="(subject, index) in item.modifiers"
                          v-bind:key="index"
                        >
                          {{ subject.title }}
                          <div v-if="!subject.duplicate">
                            <div
                              v-for="(item, j) in subject.items"
                              v-bind:key="j"
                            >
                              <li class="choice-item mt-2" v-if="item.checked">
                                {{ item.name }}
                                <span v-if="item.price > 0"
                                  >({{
                                    item.price | numFormat("0,0.00")
                                  }}
                                  ฿)</span
                                >
                              </li>
                            </div>
                          </div>
                          <div v-if="subject.duplicate">
                            <template v-for="(item, j) in subject.items">
                              <li v-if="item.quantity > 0" v-bind:key="j">
                                {{ item.name }} x{{ item.quantity }}
                              </li>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="mt-2" v-if="item.remark != null">
                        <span
                          style="clear: left; border-radius: 6px"
                          class="py-2 px-4 grey lighten-3"
                        >
                          <i class="far fa-comment-dots"></i>
                          {{ item.remark }}
                        </span>
                      </div>
                    </el-col>
                    <el-col :span="5" class="mb-3 text-right">
                      <strong
                        >฿
                        {{ item.line_subtotal | numFormat("0,0.00") }}</strong
                      >
                    </el-col>
                  </el-row>
                </div>

                <v-row class="px-3">
                  <v-col :cols="12" :sm="6" :md="6"></v-col>
                  <v-col :cols="12" :sm="6" :md="6" class="text-left">
                    <el-row :gutter="10" class="subtitle mt-3">
                      <el-col :span="12" class="mb-3">ค่าสินค้า</el-col>
                      <el-col :span="12" class="mb-3 text-right"
                        >฿ {{ order.amount.food | numFormat("0,0.00") }}</el-col
                      >
                    </el-row>
                    <el-row :gutter="10" class="subtitle">
                      <el-col :span="12" class="mb-3">VAT</el-col>
                      <el-col :span="12" class="mb-3 text-right"
                        >฿ {{ order.amount.vat | numFormat("0,0.00") }}</el-col
                      >
                    </el-row>
                    <el-row :gutter="10" class="subtitle">
                      <el-col :span="12" class="mb-3">ค่าจัดส่ง</el-col>
                      <el-col :span="12" class="mb-3 text-right"
                        >฿
                        {{
                          (parseFloat(order.amount.delivery) +
                            parseFloat(order.amount.delivery_tax))
                            | numFormat("0,0.00")
                        }}</el-col
                      >
                    </el-row>
                    <el-row
                      :gutter="10"
                      class="subtitle"
                      v-if="order.amount.extra > 0"
                    >
                      <el-col :span="12" class="mb-3"
                        >บริการเสริม (เก็บเงินปลายทาง)</el-col
                      >
                      <el-col :span="12" class="mb-3 text-right"
                        >฿
                        {{ order.amount.extra | numFormat("0,0.00") }}</el-col
                      >
                    </el-row>
                    <el-row
                      :gutter="10"
                      class="subtitle green--text promotion mb-3 py-2"
                      v-if="order.amount.discount < 0"
                    >
                      <el-col :span="12" class="mb-3">
                        ส่วนลด
                        <div
                          class="green--text font-weight-bold"
                          v-if="order.promotion_json != null"
                        >
                          <v-icon small class="green--text">fa fa-tag</v-icon>
                          {{ order.promotion_json[0].promotion_title }}
                        </div>
                      </el-col>
                      <el-col :span="12" class="mb-3 text-right"
                        >฿
                        {{
                          order.amount.discount | numFormat("0,0.00")
                        }}</el-col
                      >
                    </el-row>
                    <el-row :gutter="10" class="title font-weight-bold">
                      <el-col :span="12" class="mb-3">รวมทั้งหมด</el-col>
                      <el-col :span="12" class="mb-3 text-right"
                        >฿
                        {{ order.amount.total | numFormat("0,0.00") }}</el-col
                      >
                    </el-row>
                  </v-col>
                </v-row>
              </template>
            </section>
            <v-divider></v-divider>
            <section class="pa-3">
              <h2 class="subtitle mb-0">ภาพสินค้า</h2>
              <div class="px-0 mt-3 mb-3">
                <template v-if="order.custom_4 != null">
                  <img :src="order.custom_4" style="width: 30%" />
                </template>
                <template v-else>
                  <v-btn outlined color="primary">
                    <i class="el-icon-upload"></i> อัพโหลดภาพการชำระเงิน
                  </v-btn>
                </template>
              </div>
            </section>
            <template
              v-if="
                order.payment_type == 'creditcard' &&
                  payment != null &&
                  payment.card
              "
            >
              <v-divider></v-divider>
              <section class="pa-3">
                <h2 class="subtitle mb-3">Credit Card Info</h2>
                <v-layout>
                  <v-flex xs12>
                    <div class="mt-2">
                      <strong class="my-label">ID:</strong>
                      {{ payment.id }}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Card Name :</strong>
                      {{ payment.card.name }}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Card No. :</strong>
                      xxxx-xxxx-xxxx-{{ payment.card.last_digits }}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Card Brand :</strong>
                      {{ payment.card.brand }}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Status :</strong>
                      {{ payment.status }}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Authorized :</strong>
                      {{ payment.authorized }}
                    </div>
                  </v-flex>
                </v-layout>
              </section>
            </template>
            <v-divider></v-divider>
            <section class="pa-3" v-if="driver != null">
              <template v-if="order.driver_type == 'lalamove'">
                <h2 class="subtitle mb-3">ข้อมูลคนขับ</h2>
                <v-row
                  v-if="
                    driver.detail.status != 'ASSIGNING_DRIVER' &&
                      driver.detail.status != 'CANCELED'
                  "
                >
                  <v-col xs12>
                    <v-row>
                      <v-col cols="2" :sm="2">
                        <el-image
                          style="width: 100px; height: 100px"
                          :src="driver.driver.photo"
                          :fit="`contain`"
                        ></el-image>
                      </v-col>
                      <v-col cols="10" :sm="10">
                        <div class="mt-2">
                          <strong class="my-label">เลขที่งาน:</strong>
                          {{
                            order.driver_info_json.orderRef.substring(0, 5)
                          }}-{{
                            order.driver_info_json.orderRef.substring(5, 10)
                          }}
                        </div>
                        <div class="mt-2">
                          <strong class="my-label">สถานะ:</strong>
                          <span
                            class="red white--text py-1 px-3"
                            v-if="driver.detail.status == 'CANCELED'"
                          >
                            <i class="far fa-times-circle"></i> ยกเลิกงานแล้ว
                          </span>
                          <span
                            class="green white--text py-1 px-3"
                            v-else-if="driver.detail.status == 'COMPLETED'"
                          >
                            <i class="far fa-check-circle"></i>
                            จัดส่งเรียบร้อยแล้ว
                          </span>
                          <span class="blue white--text py-1 px-3" v-else>
                            <i class="fas fa-motorcycle"></i> กำลังดำเนินการ
                          </span>
                        </div>
                        <div class="mt-2">
                          <strong class="my-label">ชื่อคนขับ:</strong>
                          {{ driver.driver.name }} | โทร.
                          {{ driver.driver.phone }}
                        </div>
                        <!--
                      <div class="mt-2">
                        <strong class="my-label">ราคา:</strong>
                        ฿ {{driver.detail.price.amount}}
                      </div>
                        -->
                        <div class="mt-2">
                          <strong class="my-label">ติดตาม:</strong>
                          <a
                            :href="
                              `https://share.lalamove.com/?TH` +
                                order.driver_info_json.orderRef +
                                `&lang=th_TH`
                            "
                            target="_blank"
                            >https://share.lalamove.com/?TH{{
                              order.driver_info_json.orderRef
                            }}&lang=th_TH</a
                          >
                        </div>
                        <div class="mt-2">
                          <strong class="my-label">Call Center:</strong
                          >ต้องการยกเลิกงานโทร. 02-029-1494
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row v-if="driver.detail.status == 'ASSIGNING_DRIVER'">
                  <v-col xs12>
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <div class="mt-3">กำลังหาคนขับ</div>
                  </v-col>
                </v-row>
                <v-row v-if="driver.detail.status == 'CANCELED'">
                  <v-col xs12>คนขับถูกยกเลิก</v-col>
                </v-row>
              </template>
              <template v-if="order.driver_type == 'owned'">
                <h2 class="subtitle mb-3">ข้อมูลคนขับ</h2>
                <v-row v-if="driver.detail.status == 'TRACKING'">
                  <v-row>
                    <v-col :cols="2" :sm="2">
                      <el-image
                        style="width: 100px; height: 100px"
                        :src="driver.driver.photo"
                        :fit="`contain`"
                      ></el-image>
                    </v-col>
                    <v-col :cols="10" :sm="10">
                      <div class="mt-2">
                        <strong class="my-label">สถานะ:</strong>
                        <span
                          class="red white--text py-1 px-3"
                          v-if="driver.detail.status == 'CANCELED'"
                        >
                          <i class="far fa-times-circle"></i> ยกเลิกงานแล้ว
                        </span>
                        <span
                          class="green white--text py-1 px-3"
                          v-else-if="driver.detail.status == 'COMPLETED'"
                        >
                          <i class="far fa-check-circle"></i>
                          จัดส่งเรียบร้อยแล้ว
                        </span>
                        <span class="blue white--text py-1 px-3" v-else>
                          <i class="fas fa-motorcycle"></i> กำลังดำเนินการ
                        </span>
                      </div>
                      <div class="mt-2">
                        <strong class="my-label">ชื่อคนขับ:</strong>
                        {{ driver.driver.name }} | โทร.
                        {{ driver.driver.phone }}
                      </div>
                    </v-col>
                  </v-row>
                </v-row>
              </template>
            </section>
          </el-card>
        </div>
      </v-flex>
      <v-flex
        xs12
        sm12
        md4
        :class="{ 'pl-4 mt-0': $vuetify.breakpoint.mdAndUp }"
      >
        <div class="sticky">
          <el-card class="box-card">
            <div style="margin-top: 15px">
              <el-input placeholder="Please input" v-model="shareUrl">
                <template slot="append">
                  <i class="far fa-copy"></i>
                </template>
              </el-input>
            </div>
            <v-divider class="my-3"></v-divider>
            <h3 class="subtitle pb-1 pt-4">การชำระเงิน</h3>
            <template v-if="order.shop_id != 369">
              <v-layout class="mt-3" v-if="order.payment_type == 'transfer'">
                <v-flex xs12 class="text-center">
                  <div
                    v-if="order.payment.payment_image_url != null"
                    class="pa-3 mb-3"
                    style="background-color: #eee; border-radius: 12px"
                  >
                    <h6 class="font-weight-bold font-secondary">
                      อัพโหลดโดยลูกค้า
                    </h6>
                    <img
                      :src="order.payment.payment_image_url"
                      style="width: 100%"
                    />
                  </div>
                  <div
                    v-if="order.payment.payment_image_url_admin != null"
                    class="pa-3 mb-3"
                    style="background-color: #eee; border-radius: 12px"
                  >
                    <h6 class="font-weight-bold font-secondary">
                      อัพโหลดโดยแอดมิน
                    </h6>
                    <img
                      :src="order.payment.payment_image_url_admin"
                      style="width: 100%"
                    />
                  </div>
                  <div
                    v-if="
                      order.payment.payment_image_url == null &&
                        order.payment.payment_image_url_admin == null
                    "
                    class="my-2 text-center"
                  >
                    ยังไม่มีหลักฐานการชำระเงิน
                  </div>
                  <template
                    v-if="order.status == 'pending' || order.status == 'new'"
                  >
                    <el-upload
                      class="upload"
                      :on-success="handleSuccess"
                      :file-list="file"
                      :action="
                        deliveryApiDomain +
                          `/console/orders/` +
                          order.order_reference +
                          `/upload`
                      "
                      :headers="uploadHeaders"
                    >
                      <v-btn block outlined color="primary">
                        <i class="el-icon-upload"></i> อัพโหลดภาพการชำระเงิน
                      </v-btn>
                    </el-upload>
                  </template>
                </v-flex>
              </v-layout>
              <v-row v-if="order.payment_type == 'qr'">
                <v-col>
                  <div
                    v-if="order.payment.paid_at != null"
                    class="text-center green--text font-weight-bold"
                    style="font-size:1rem"
                  >
                    <i class="far fa-check-circle"></i>
                    <br />
                    ชำระแล้วด้วย QR Promptpay
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="order.payment_type == 'creditcard'">
                <v-col>
                  <div
                    v-if="order.payment.paid_at != null"
                    class="text-center green--text font-weight-bold"
                    style="font-size:1rem"
                  >
                    <i class="far fa-check-circle"></i>
                    <br />
                    ชำระแล้วด้วยบัตรเครดิต
                  </div>
                </v-col>
              </v-row>
              <v-divider class="my-3"></v-divider>
            </template>
            <template v-else>
              <v-row>
                <v-col
                  :cols="12"
                  v-for="(item, index) in order.payments"
                  :key="index"
                  class="text-center"
                >
                  <img :src="item.payment_image_url" style="width: 70%" />
                  <div v-if="item.slip2go_json">
                    <v-chip
                      v-if="item.slip2go_json.code == 200200"
                      color="green"
                      dark
                      >สลิปถูกต้อง ยอดเงิน :
                      {{ item.slip2go_json.data.amount }} บาท</v-chip
                    >
                    <v-chip v-else color="orange" dark else>
                      อาจเป็นสลิปปลอม
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
            </template>
            <section v-if="actions != null">
              <template v-if="actions.status">
                <h3 class="subtitle pb-1 pt-4">สถานะ</h3>
                <v-btn
                  class="my-2"
                  v-for="(btn, index) in actions.status"
                  :key="index"
                  :depressed="btn.type == 'depressed'"
                  :outlined="btn.type == 'outlined'"
                  :color="btn.color"
                  block
                  dark
                  @click="onUpdateStatusTo(btn.action)"
                  >{{ btn.title }}</v-btn
                >
              </template>

              <template v-if="actions.content">
                <h3 class="subtitle pb-1 pt-4">แก้ไข</h3>
                <v-list>
                  <template v-for="(item, index) in actions.content">
                    <v-list-item
                      :key="index"
                      @click="onActionClicked(item.action)"
                    >
                      <v-list-item-icon>
                        <v-icon small>{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`d-` + index"></v-divider>
                  </template>
                </v-list>
              </template>

              <template v-if="actions.driver">
                <h3 class="subtitle pb-1 pt-4">การขนส่ง</h3>
                <v-list>
                  <template v-for="(item, index) in actions.driver">
                    <v-list-item
                      :key="index"
                      @click="onActionClicked(item.action)"
                    >
                      <v-list-item-icon>
                        <v-icon small>{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`x-` + index"></v-divider>
                  </template>
                </v-list>
              </template>

              <template v-if="actions.lalamove">
                <h3 class="subtitle pb-1 pt-4">การขนส่ง</h3>
                <v-list>
                  <template v-for="(item, index) in actions.lalamove">
                    <v-list-item
                      :key="index"
                      @click="onActionClicked(item.action)"
                    >
                      <v-list-item-icon>
                        <v-icon small>{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`y-` + index"></v-divider>
                  </template>
                </v-list>
              </template>

              <div>
                <h3 class="subtitle pb-1 pt-4">อื่นๆ</h3>
                <v-list>
                  <v-list-item @click="customFieldDialog = true">
                    <v-list-item-icon>
                      <v-icon small>fas fa-camera</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>รูปภาพสินค้า</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="recieptDialog = true">
                    <v-list-item-icon>
                      <v-icon small>fas fa-receipt</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>ดูใบรายการ</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="print()">
                    <v-list-item-icon>
                      <v-icon small>fas fa-print</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>พิมพ์ใบรายการ</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="printBox()">
                    <v-list-item-icon>
                      <v-icon small>fas fa-print</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        >พิมพ์ใบติดกล่องพัสดุ</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="activitiesDialog = true">
                    <v-list-item-icon>
                      <v-icon small>fas fa-list-ol</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>การเคลื่อนไหว</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="downloadPDF()">
                    <v-list-item-icon>
                      <v-icon small>fas fa-file-download</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>ดาวน์โหลดใบเสร็จ</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </div>
            </section>
            <template v-else>
              <v-skeleton-loader
                :loading="true"
                type="list-item-two-line"
              ></v-skeleton-loader>
              <v-skeleton-loader
                :loading="true"
                type="list-item-two-line"
              ></v-skeleton-loader>
              <v-skeleton-loader
                :loading="true"
                type="list-item-two-line"
              ></v-skeleton-loader>
            </template>
          </el-card>
        </div>
      </v-flex>
    </v-layout>

    <!-- RECEIPT DIALOG -->
    <el-dialog
      title="ใบรายการ"
      v-if="order != null"
      width="435px"
      center
      :visible.sync="recieptDialog"
    >
      <div id="print-area" class="mx-5" style="font-size: 0.8rem">
        <v-layout class="mb-5 mx-0" row wrap>
          <v-flex xs12>
            <el-row class="mt-2 subtitle">
              <el-col :span="12">
                <strong>หมายเลขออเดอร์ :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right"
                >{{ order.order_reference }}-{{
                  order.order_id | numFormat("00000")
                }}</el-col
              >
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>สร้างเมื่อ :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">{{
                order.created_at | moment("DD/MM/YYYY HH:mm")
              }}</el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ประเภทการสั่งซื้อ :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                <div v-if="order.order_type == 'pickup'">
                  <i class="fas fa-shopping-bag"></i> รับเองที่ร้าน
                </div>
                <div v-if="order.order_type == 'delivery'">
                  <i class="fas fa-motorcycle"></i> เดลิเวอรี่
                </div>
                <div v-if="order.order_type == 'commerce'">
                  <i class="fas fa-shopping-cart"></i> อีคอมเมิร์ซ
                </div>
                <div v-if="order.order_type == 'coupon'">
                  <i class="fas fa-ticket-alt"></i> คูปอง/วอเชอร์โค้ด
                </div>
                <div
                  v-if="
                    order.order_type == 'dinein' ||
                      order.order_type == 'dinein-buffet'
                  "
                >
                  <i class="fas fa-chair"></i> นั่งทานที่ร้าน
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>การชำระเงิน :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                <div v-if="order.payment_type == 'transfer'">โอนเงิน</div>
                <div v-if="order.payment_type == 'cash'">ชำระเงินสด</div>
                <div v-if="order.payment_type == 'qr'">พร้อมเพย์</div>
                <div v-if="order.payment_type == 'creditcard'">บัตรเครดิต</div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ช่องทางการขาย :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                <div v-if="order.order_channel == 'liff'">
                  Line Official Account
                </div>
                <div v-else>{{ order.order_channel }}</div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ข้อมูลลูกค้า :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                {{ order.user_ref_json.firstname }}
                {{ order.user_ref_json.lastname }}
                -
                <i class="fas fa-mobile-alt"></i>
                {{ order.user_ref_json.mobile }}
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ที่อยุ่จัดส่ง :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                {{ order.user_address.place_detail.address }}
                {{ order.user_address.place_detail.sub_district }}
                {{ order.user_address.place_detail.district }}
                {{ order.user_address.place_detail.province }}
                {{ order.user_address.place_detail.postcode }}
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>Sale Channel :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                {{ order.sale_channel }}
              </el-col>
            </el-row>
          </v-flex>
        </v-layout>

        <template v-if="order.order_basket.product_list.length > 0">
          <el-row
            :gutter="10"
            v-for="(item, index) in order.order_basket.product_list"
            v-bind:key="index"
          >
            <el-col :span="2" class="mb-3">
              <span>{{ item.quantity }} x</span>
            </el-col>
            <el-col :span="17" class="mb-3">
              {{ item.name }}
              <p class="grey--text">{{ item.excerpt }}</p>
              <div v-if="item.modifiers != null">
                <div
                  class="modifiers"
                  style="padding-left: 20px"
                  v-for="(subject, index) in item.modifiers"
                  v-bind:key="index"
                >
                  {{ subject.title }}
                  <div v-if="!subject.duplicate">
                    <div v-for="(item, j) in subject.items" v-bind:key="j">
                      <li class="choice-item" v-if="item.checked">
                        {{ item.name }}
                      </li>
                    </div>
                  </div>
                  <div v-if="subject.duplicate">
                    <li v-for="(item, j) in subject.items" v-bind:key="j">
                      {{ item.name }} {{ item.checked }}
                    </li>
                  </div>
                </div>
              </div>
              <div class="mt-0" v-if="item.remark != null">
                Remark : {{ item.remark }}
              </div>
            </el-col>
            <el-col :span="5" class="mb-3 text-right" style="text-align: right"
              >฿
              {{
                (item.regular_price * item.quantity) | numFormat("0,0")
              }}</el-col
            >
          </el-row>
          <v-divider class="my-2"></v-divider>
          <el-row :gutter="10" class="subtitle">
            <el-col :span="12" class="mb-3">ค่าสินค้า</el-col>
            <el-col :span="12" class="mb-3 text-right" style="text-align: right"
              >฿ {{ order.amount.food | numFormat("0,0.00") }}</el-col
            >
          </el-row>
          <el-row :gutter="10" class="subtitle">
            <el-col :span="12" class="mb-3">VAT</el-col>
            <el-col :span="12" class="mb-3 text-right" style="text-align: right"
              >฿ {{ order.amount.vat | numFormat("0,0.00") }}</el-col
            >
          </el-row>

          <el-row
            :gutter="10"
            class="subtitle"
            v-if="order.amount.discount < 0"
          >
            <el-col :span="12" class="mb-3">ส่วนลด</el-col>
            <el-col :span="12" class="mb-3 text-right" style="text-align: right"
              >฿ {{ order.amount.discount | numFormat("0,0.00") }}</el-col
            >
          </el-row>

          <el-row :gutter="10" class="title">
            <el-col :span="12" class="mb-2">รวม</el-col>
            <el-col :span="12" class="mb-2 text-right" style="text-align: right"
              >฿
              {{
                (parseFloat(order.amount.food) + parseFloat(order.amount.vat))
                  | numFormat("0,0.00")
              }}</el-col
            >
          </el-row>

          <v-divider class="my-2"></v-divider>

          <el-row :gutter="10" class="subtitle">
            <el-col :span="12" class="mb-3">ค่าจัดส่ง</el-col>
            <el-col :span="12" class="mb-3 text-right" style="text-align: right"
              >฿
              {{
                (parseFloat(order.amount.delivery) +
                  parseFloat(order.amount.delivery_tax))
                  | numFormat("0,0.00")
              }}</el-col
            >
          </el-row>
          <el-row :gutter="10" class="subtitle" v-if="order.amount.extra > 0">
            <el-col :span="12" class="mb-2">ค่าบริการอื่นๆ</el-col>
            <el-col :span="12" class="mb-2 text-right" style="text-align: right"
              >฿ {{ order.amount.extra | numFormat("0,0.00") }}</el-col
            >
          </el-row>

          <el-row :gutter="10" class="title">
            <el-col :span="12" class="mb-3">รวมทั้งหมด</el-col>
            <el-col :span="12" class="mb-3 text-right" style="text-align: right"
              >฿
              {{ parseFloat(order.amount.total) | numFormat("0,0.00") }}</el-col
            >
          </el-row>
        </template>
        <div class="my-0 text-right" style="text-align: right">
          ***
          <span v-if="order.order_type == 'delivery'">จัดส่ง</span>
          <span v-if="order.order_type == 'pickup'">รับอาหาร</span>
          {{ order.datetime_received | moment("DD/MM/YYYY HH:mm") }}
        </div>
        <!--
        <div v-if="order.remark_public!=''" class="my-0 text-left">{{order.remark_public}} ***</div>
        -->
        <v-divider></v-divider>
        <!--
        <div v-if="order.payment_type=='cash'" class="my-3 text-center">
          <label>โปรดชำระเงินที่</label>
          <div>019-1-80933-5</div>
          <div>บจก. ฮาลาลไลซ์ | ธนาคารกสิกรไทย</div>
        </div>
        -->
        <div class="my-3 text-center" style="text-align: center">
          <div style="font-size: 2rem">Thank You</div>
        </div>
      </div>
      <v-btn block depressed color="primary" @click="print()"
        >พิมพ์ใบรายการ</v-btn
      >
    </el-dialog>

    <!-- LABEL DIALOG -->
    <el-dialog
      title="ใบติดกล่องพัสดุ"
      v-if="order != null"
      width="435px"
      center
      :visible.sync="labelDialog"
    >
      <div id="print-label-area" class="mx-3" style="font-size: 0.8rem">
        <div style="position: relative">
          <div style="position: absolute; top: 30px; left: 30px">
            <v-row v-if="order.shop_id == 369">
              <v-col class="text-center">
                <div style="font-size: 1rem">ผู้ส่ง</div>
                <div style="font-size: 1rem">
                  บริษัท ลิ่ว-ชา คอฟฟี่ จำกัด (สำนักงานใหญ่)
                  <div style="font-size: 1rem">
                    51/139 หมู่3 ต.คลองหนึ่ง <br />
                    อำเภอคลองหลวง จังหวัดปทุมธานี 10120
                  </div>
                  <div>โทร. 096-875-3279</div>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="order.shop_id == 172">
              <v-col class="text-center">
                <div style="font-size: 1rem">ผู้ส่ง</div>
                <div style="font-size: 1rem">
                  บริษัท ฟารีดา ดราย ฟรุ๊ตส์ จำกัด
                  <div style="font-size: 1rem">
                    288/5-8 ถ.พัฒนาการ สวนหลวง <br />
                    สวนหลวง กทม. 10250
                  </div>
                  <div>(โชติกา 0991148433)</div>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="order.shop_id == 432">
              <v-col class="text-center">
                <div style="font-size: 1rem">ผู้ส่ง</div>
                <div style="font-size: 1rem">
                  บริษัท ซัลมาฮาลาล บีเคเค จำกัด (สำนักงานใหญ่)
                  <div style="font-size: 1rem">
                    199 ถนนเคหะร่มเกล้า แขวงคลองสองต้นนุ่น เขตลาดกระบัง
                    กรุงเทพมหานคร
                  </div>
                  <div>โทร. 083-909-7423, 095-751-5306</div>
                </div>
              </v-col>
            </v-row>
          </div>
          <div
            style="position: absolute; top: 200px; left: 200px; width: 600px"
          >
            <v-row>
              <v-col class="text-center">
                <div style="font-size: 1.6rem">ผู้รับ</div>
                <div style="font-size: 1.6rem">
                  {{ order.user_ref_json.firstname }}
                  {{ order.user_ref_json.lastname }}
                  <div style="font-size: 1.6rem">
                    {{ order.user_address.place_detail.address }}
                  </div>
                  <div>โทร. {{ order.user_ref_json.mobile }}</div>
                </div>
              </v-col>
            </v-row>
          </div>

          <div style="position: absolute; top: 700px; left: 30px">
            <v-row v-if="order.shop_id == 369">
              <v-col class="text-center">
                <div style="font-size: 1rem">ผู้ส่ง</div>
                <div style="font-size: 1rem">
                  บริษัท ลิ่ว-ชา คอฟฟี่ จำกัด (สำนักงานใหญ่)
                  <div style="font-size: 1rem">
                    51/139 หมู่3 ต.คลองหนึ่ง <br />
                    อำเภอคลองหลวง จังหวัดปทุมธานี 10120
                  </div>
                  <div>โทร. 096-875-3279</div>
                </div>
              </v-col>
            </v-row>
            <!-- ARME -->
            <v-row v-if="order.shop_id == 432">
              <v-col class="text-center">
                <div style="font-size: 1rem">ผู้ส่ง</div>
                <div style="font-size: 1rem">
                  บริษัท ซัลมาฮาลาล บีเคเค จำกัด (สำนักงานใหญ่)
                  <div style="font-size: 1rem">
                    199 ถนนเคหะร่มเกล้า แขวงคลองสองต้นนุ่น เขตลาดกระบัง
                    กรุงเทพมหานคร
                  </div>
                  <div>โทร. 083-909-7423, 095-751-5306</div>
                </div>
              </v-col>
            </v-row>
          </div>
          <div
            style="position: absolute; top: 850px; left: 200px; width: 600px"
          >
            <v-row>
              <v-col class="text-center">
                <div style="font-size: 1.6rem">ผู้รับ</div>
                <div style="font-size: 1.6rem">
                  {{ order.user_ref_json.firstname }}
                  {{ order.user_ref_json.lastname }}
                  <div style="font-size: 1.6rem">
                    {{ order.user_address.place_detail.address }}
                  </div>
                  <div>โทร. {{ order.user_ref_json.mobile }}</div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- RESCHEDULE DIALOG -->
    <v-dialog v-model="reScheduleDialog" scrollable max-width="550px">
      <v-card>
        <v-card-title>
          <strong>แก้ไขเวลาจัดส่ง</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="text-center ma-3">
            เวลาเดิม {{ order.datetime_received | moment("DD/MM/YYYY HH:mm") }}
          </div>

          <div class="text-center ma-3">
            <el-date-picker
              v-model="new_datetime_received"
              type="datetime"
              :format="`dd/MM/yyyy HH:mm`"
              :picker-options="pickerOptions"
              placeholder="เลือกเวลาจัดส่งใหม่"
              default-time="12:00:00"
              :size="`large`"
              style="width: 100%"
            ></el-date-picker>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" depressed @click="reScheduleDialog = false"
            >ปิด</v-btn
          >
          <v-btn color="primary" depressed @click="onReSchedule()"
            >ยืนยัน</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ADJUST DELIVERY FREE DIALOG -->
    <v-dialog v-model="adjDeliveryFeeDialog" scrollable max-width="550px">
      <v-card>
        <v-card-title>
          <strong>แก้ไขค่าจัดส่ง</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="my-5">
          <div class="text-center ma-3">
            ค่าจัดส่งเดิม ฿
            {{
              (parseFloat(order.amount.delivery) +
                parseFloat(order.amount.delivery_tax))
                | numFormat("0,0.00")
            }}
          </div>
          <el-input
            placeholder="Please Input"
            v-model="newDeliveryFee"
          ></el-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" depressed @click="adjDeliveryFeeDialog = false"
            >ปิด</v-btn
          >
          <v-btn color="primary" depressed @click="onAdjDeliveryFee()"
            >ยืนยัน</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CANCEL DRIVER DIALOG -->
    <v-dialog v-model="cancelDriverDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>
          <strong>ต้องการยกเลิกคนขับใช่หรือไม่?</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50px"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" depressed @click="cancelDriverDialog = false"
            >ปิด</v-btn
          >
          <v-btn color="primary" depressed @click="cancelDriver()">ใช่</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- RESET DIALOG -->
    <v-dialog v-model="confirmToResetDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>
          <strong>ต้องการรีเซ็ตออเดอร์นี้ใช่หรือไม่?</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50px"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" depressed @click="confirmToResetDialog = false"
            >ปิด</v-btn
          >
          <v-btn
            color="primary"
            depressed
            @click="onUpdateStatusTo('new', true)"
            >ใช่</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ACCEPT DIALOG -->
    <v-dialog v-model="confirmToAcceptedDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>
          <strong>ต้องการยืนยันออเดอร์นี้ใช่หรือไม่?</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50px"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            depressed
            @click="confirmToAcceptedDialog = false"
            >ปิด</v-btn
          >
          <v-btn
            color="primary"
            depressed
            @click="onUpdateStatusTo('accepted', true)"
            >ใช่</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- PROCESSING DIALOG -->
    <v-dialog v-model="confirmToProcessingDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>
          <strong>ต้องการส่งออเดอร์นี้ให้สาขาใช่หรือไม่?</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50px"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            depressed
            @click="confirmToProcessingDialog = false"
            >ปิด</v-btn
          >
          <v-btn
            color="primary"
            depressed
            @click="onUpdateStatusTo('processing', true)"
            >ใช่</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- COOKING DIALOG -->
    <v-dialog v-model="confirmToCookingDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>
          <strong>ต้องการยืนยันออเดอร์นี้ใช่หรือไม่?</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50px"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" depressed @click="confirmToCookingDialog = false"
            >ปิด</v-btn
          >
          <v-btn
            color="primary"
            depressed
            @click="onUpdateStatusTo('cooking', true)"
            >ใช่</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- COMPLETE DIALOG -->
    <v-dialog v-model="confirmToCompletedDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>
          <strong>ออเดอร์นี้เสร็จสมบูรณ์แล้วหรือไม่?</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50px"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            depressed
            @click="confirmToCompletedDialog = false"
            >ปิด</v-btn
          >
          <v-btn
            color="primary"
            depressed
            @click="onUpdateStatusTo('completed', true)"
            >ใช่</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ACTIVITIES DIALOG -->
    <v-dialog v-model="activitiesDialog" scrollable max-width="500px">
      <v-card>
        <v-card-title>
          <strong>รายการเคลื่อนไหว (Log)</strong>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text style="height: 540px">
          <v-timeline dense clipped v-if="order != null">
            <template v-for="(item, index) in order.remark_internal">
              <v-timeline-item
                v-if="item != ''"
                :key="index"
                fill-dot
                class="mb-3"
                color="primary"
                small
                >{{ item }}</v-timeline-item
              >
            </template>
          </v-timeline>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" depressed @click="activitiesDialog = false"
            >ปิด</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CANCEL DIALOG -->
    <v-dialog v-model="cancelOrderDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>
          <strong>เหตุผลในการยกเลิกออเดอร์</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 350px">
          <v-radio-group v-model="cancelReason">
            <v-radio
              class="mt-2"
              color="primary"
              label="ติดต่อร้านค้าไม่ได้"
              value="ติดต่อร้านค้าไม่ได้"
            ></v-radio>
            <v-radio
              class="mt-2"
              color="primary"
              label="ร้านค้าปิดทำการ"
              value="ร้านค้าปิดทำการ"
            ></v-radio>
            <v-radio
              class="mt-2"
              color="primary"
              label="อาหารหมด"
              value="อาหารหมด"
            ></v-radio>
            <v-radio
              class="mt-2"
              color="primary"
              label="เรียกคนขับไม่ได้"
              value="เรียกคนขับไม่ได้"
            ></v-radio>
            <v-radio
              class="mt-2"
              color="primary"
              label="ลูกค้ายกเลิก"
              value="ลูกค้ายกเลิก"
            ></v-radio>
            <v-radio
              class="mt-2"
              color="primary"
              label="ออเดอร์ทดสอบ"
              value="ออเดอร์ทดสอบ"
            ></v-radio>
            <v-radio
              class="mt-2"
              color="primary"
              label="อื่นๆ"
              value="อื่นๆ"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" depressed @click="cancelOrderDialog = false"
            >ปิด</v-btn
          >
          <v-btn
            color="primary"
            depressed
            @click="onUpdateStatusTo('cancelled', true)"
            >บันทึก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <lalamove-dialog
      :deliveryData="deliveryData"
      :order="order"
      :showDialog="lalamoveDialog"
      @save="onSaveLalamove"
      @close="onRequestLalamoveClose"
    ></lalamove-dialog>

    <driver-dialog
      :order="order"
      :showDialog="driverDialog"
      @save="onSaveDriver"
      @close="onDriverDialogClose"
    ></driver-dialog>

    <dc-dialog
      :order_reference="order_ref"
      :showDialog="dcDialog"
      @save="onDcSelected"
      @close="onDcClosed"
    ></dc-dialog>

    <edit-basket-dialog
      :items.sync="basket"
      :showDialog="editBasketDialog"
      @save="onEditBasketSaved"
      @close="onEditBasketClosed"
    ></edit-basket-dialog>

    <order-custom-field-dialog
      :showDialog="customFieldDialog"
      :order_id="order.order_id"
      :order_reference="order.order_reference"
      :custom_1="order.custom_1"
      @close="customFieldDialog = false"
    >
    </order-custom-field-dialog>
  </v-container>
</template>
<script>
import { deliveryApiDomain, harisChannelKey } from "@/utils/Constants";

import Service from "@/services";

import LalamoveDialog from "@/components/LalamoveDialog";
import DcDialog from "@/components/DcDialog";
import DriverDialog from "@/components/DriverDialog";
import EditBasketDialog from "@/components/EditBasketDialog";
import OrderCustomFieldDialog from "@/components/order/CustomFieldDialog";
import VLazyImage from "v-lazy-image";

import moment from "moment";
import { colors } from "vuetify/lib";

export default {
  components: {
    LalamoveDialog,
    EditBasketDialog,
    DcDialog,
    DriverDialog,
    OrderCustomFieldDialog,
    VLazyImage,
  },
  props: ["order_ref"],
  data() {
    return {
      deliveryApiDomain: deliveryApiDomain,
      loading: null,
      order: null,
      basket: null,
      payment: null,
      driver: null,
      shareUrl: "",
      recipient: { name: "", mobile: "" },
      cancelReason: null,
      lalamoveDialog: false,
      dcDialog: false,
      driverDialog: false,
      deliveryData: null,
      recieptDialog: false,
      labelDialog: false,
      reScheduleDialog: false,
      adjDeliveryFeeDialog: false,
      cancelOrderDialog: false,
      cancelDriverDialog: false,
      activitiesDialog: false,
      confirmToResetDialog: false,
      confirmToAcceptedDialog: false,
      confirmToProcessingDialog: false,
      confirmToCookingDialog: false,
      confirmToCompletedDialog: false,
      editBasketDialog: false,
      customFieldDialog: false,
      file: [],
      uploadHeaders: {
        Authorization: "",
      },
      steps: [1, 0, 0, 0, 0, 0],
      newDeliveryFee: 0,
      gg_url: "",
      driverInterval: null,
      new_datetime_received: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= new Date().setDate(new Date().getDate() - 1);
        },
      },
      actions: null,
    };
  },
  computed: {},
  created() {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    this.uploadHeaders.Authorization = "Bearer " + accessToken;
    this.loadOrder();
  },
  methods: {
    loadOrder() {
      this.showLoading();
      this.actions = null;
      Promise.all([
        this.$store
          .dispatch("Order/getOrderByRef", this.order_ref)
          .then((res) => {
            if (res.status == "ok") {
              this.order = res.data;
              const o = Object.assign({}, this.order.order_basket);
              this.basket = o.product_list;
              this.new_datetime_received = this.order.datetime_received;

              console.log(this.order.amount);
              this.newDeliveryFee =
                parseFloat(this.order.amount.delivery) +
                parseFloat(this.order.amount.delivery_tax);
              if (this.order.status == "new") {
                this.steps[1] = 1;
              }
              if (this.order.status == "accepted") {
                this.steps[1] = 1;
                this.steps[2] = 1;
              }
              if (this.order.status == "processing") {
                this.steps[1] = 1;
                this.steps[2] = 1;
                this.steps[3] = 1;
              }
              if (
                this.order.status == "cooking" ||
                this.order.status == "ready-to-go" ||
                this.order.status == "delivering"
              ) {
                this.steps[1] = 1;
                this.steps[2] = 1;
                this.steps[3] = 1;
                this.steps[4] = 1;
              }
              if (this.order.status == "completed") {
                this.steps[1] = 1;
                this.steps[2] = 1;
                this.steps[3] = 1;
                this.steps[4] = 1;
                this.steps[5] = 1;
              }
              this.shareUrl =
                "https://get.hlzd.link/o/" +
                this.order.order_reference.toLowerCase();
              this.checkRecipient();
            }

            if (this.order.order_type == "delivery") {
              let origin =
                this.order.delivery_info_json.whereFrom.latitude +
                "," +
                this.order.delivery_info_json.whereFrom.longitude;
              let destination =
                this.order.delivery_info_json.whereTo.lat +
                "," +
                this.order.delivery_info_json.whereTo.lng;

              this.gg_url =
                "https://www.google.com/maps/dir/?api=1&origin=" +
                origin +
                "&destination=" +
                destination;
            }
          }),

        this.$store
          .dispatch("Order/getOrderPayment", this.order_ref)
          .then((res) => {
            this.payment = res.data;
          }),
      ]).then(() => {
        this.hideLoading();

        setTimeout(() => {
          this.$store
            .dispatch("Order/getOrderDriver", this.order.order_id)
            .then((res) => {
              this.driver = res.data;
            });
          this.$store
            .dispatch("Order/getActions", this.order.order_reference)
            .then((res) => {
              this.actions = res.data;
            });
        }, 1000);
      });
    },
    checkRecipient() {
      if (this.order.user_recipient == null) {
        this.recipient.name = this.order.user_ref_json.firstname;
        this.recipient.mobile = this.order.user_ref_json.mobile;
      } else {
        this.recipient.name = this.order.user_recipient.recipient_name;
        this.recipient.mobile = this.order.user_recipient.recipient_mobile;
      }
    },
    onReSchedule() {
      let new_dt = moment(this.new_datetime_received);
      let old_dt = moment();

      if (new_dt.diff(old_dt) <= 0) {
        alert("วันเวลาจัดส่งใหม่ผ่านมาแล้ว");
        return;
      }

      Service.Order.updateDatetime(this.order.order_reference, {
        datetime_received: moment(this.new_datetime_received).format(
          "YYYY-MM-DD HH:mm"
        ),
      }).then((res) => {
        if (res.success) {
          this.order.datetime_received = res.data.datetime_received;
          this.reScheduleDialog = false;

          this.$notify({
            title: "สำเร็จ",
            message: "แก้ไขเวลาจัดส่งเรียบร้อยแล้ว",
            type: "success",
          });
        }
      });
    },
    onAdjDeliveryFee() {
      let data = {
        delivery_fee: this.newDeliveryFee,
      };
      Service.Order.updateFee(this.order.order_id, data).then((res) => {
        this.adjDeliveryFeeDialog = false;
        this.loadOrder();
        this.$notify({
          title: "สำเร็จ",
          message: "แก้ไขค่าจัดส่งเรียบร้อย",
          type: "success",
        });
      });
    },
    onRequestLalamoveOpen() {
      this.deliveryData = {
        orderId: this.order.order_id,
        datetimeReceived: this.order.datetime_received,
        deliveryInfo: this.order.delivery_info_json,
        recipientInfo: this.order.user_ref_json,
      };
      this.lalamoveDialog = true;
    },
    onRequestLalamoveClose() {
      this.delivery_info = null;
      this.lalamoveDialog = false;
    },
    onSaveLalamove() {
      this.delivery_info = null;
      this.lalamoveDialog = false;

      this.$notify({
        title: "แจ้งเตือน",
        message: "กำลังหาคนขับ...กรุณารอซักครู่",
      });

      this.$store
        .dispatch("Order/getOrderDriver", this.order.order_id)
        .then((res) => {
          this.driver = res.data;
        });

      this.driverInterval = setInterval(() => {
        this.$store
          .dispatch("Order/getOrderDriver", this.order.order_id)
          .then((res) => {
            this.driver = res.data;
            if (this.driver.detail.status != "ASSIGNING_DRIVER") {
              clearInterval(this.driverInterval);
              this.loadOrder();

              this.$notify({
                title: "สำเร็จ",
                message: "คนขับรับงานของคุณแล้ว",
                type: "success",
              });
            }
          });
      }, 10000);
    },
    onDriverDialogClose() {
      this.driverDialog = false;
    },
    onSaveDriver() {},
    onUpdateStatusTo(status, force = false) {
      if (force) {
        this.showLoading();
        let data = {
          status: status,
          remark_internal: "",
        };

        if (status == "cancelled") {
          data.remark_internal = this.cancelReason;
        }

        Service.Order.updateStatus(this.order.order_id, data)
          .then((res) => {
            if (res.success) {
              this.cancelOrderDialog = false;
              this.confirmToResetDialog = false;
              this.confirmToAcceptedDialog = false;
              this.confirmToProcessingDialog = false;
              this.confirmToCompletedDialog = false;
              this.confirmToCookingDialog = false;
              this.loadOrder();

              this.$notify({
                title: "สำเร็จ",
                message: "อัพเดทสถานะเรียบร้อยแล้ว",
                type: "success",
              });
            }
          })
          .catch((e) => {
            this.hideLoading();
            this.$notify({
              title: "Oops!",
              message: "ไม่สามารถแก้ไขสถานะได้",
              type: "warning",
            });
          });
      } else {
        if (status == "cancelled") {
          this.cancelOrderDialog = true;
        }
        if (status == "new") {
          this.confirmToResetDialog = true;
        }
        if (status == "accepted") {
          this.confirmToAcceptedDialog = true;
        }
        if (status == "processing") {
          this.confirmToProcessingDialog = true;
        }
        if (status == "cooking") {
          this.confirmToCookingDialog = true;
        }
        if (status == "completed") {
          this.confirmToCompletedDialog = true;
        }
        if (status == "select-dc") {
          this.dcDialog = true;
        }
      }
    },
    onCapturePayment() {
      Service.Order.capturePayment(this.order.order_id).then((res) => {
        if (res.success) {
          this.$store
            .dispatch("Order/getOrderPayment", this.order_id)
            .then((res) => {
              this.payment = res.data;
            });
        }
      });
    },
    onRefundPayment() {},
    onActionClicked(action) {
      if (action == "change-time") {
        this.reScheduleDialog = true;
      }
      if (action == "request-lalamove") {
        this.onRequestLalamoveOpen();
      }
      if (action == "select-driver") {
        this.driverDialog = true;
      }
      if (action == "cancel-driver") {
        this.cancelDriverDialog = true;
      }
      if (action == "change-delivery-fee") {
        this.adjDeliveryFeeDialog = true;
      }
      if (action == "edit_items") {
        this.editBasketDialog = true;
      }
      if (action == "change-custom_1") {
        this.customFieldDialog = true;
      }
      if (action == "update-basket") {
        this.onUpdateBasket();
      }
    },
    onDcSelected() {
      this.dcDialog = false;
    },
    onDcClosed(resp) {
      this.dcDialog = false;
      if (resp) {
        this.$notify({
          title: "สำเร็จ",
          message: "ส่งออเดอร์ให้ร้านค้าตัวแทนแล้ว",
          type: "success",
        });

        this.loadOrder();
      }
    },
    onUpdateBasket() {
      let d = {
        order_id: this.order.order_id,
        basket: this.basket,
      };

      Service.Order.updateBasket(d).then((res) => {
        if (res.success) {
          this.loadOrder();
        }
      });
    },
    onEditBasketSaved(data) {
      let d = {
        order_id: this.order.order_id,
        basket: data,
      };

      Service.Order.updateBasket(d).then((res) => {
        if (res.success) {
          this.loadOrder();
        }
      });
      this.editBasketDialog = false;
    },
    onEditBasketClosed() {
      this.editBasketDialog = false;
    },
    cancelDriver() {
      Service.Order.cancelDriver(this.order.order_id).then((res) => {
        if (res.success) {
          if (res.data.done) {
            this.cancelDriverDialog = false;
            this.$store
              .dispatch("Order/getOrderDriver", this.order.order_id)
              .then((res) => {
                this.driver = res.data;

                this.$notify({
                  title: "สำเร็จ",
                  message: "ยกเลิกคนขับเรียบร้อยแล้ว",
                  type: "success",
                });
              });
          } else {
            this.$notify({
              title: "Oops!",
              message: "ไม่สามารถยกเลิกคนขับได้",
              type: "warning",
            });
          }
        }
      });
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    print() {
      if (!this.recieptDialog) {
        this.recieptDialog = true;
      }
      setTimeout(() => {
        this.$htmlToPaper("print-area", null, () => {
          this.recieptDialog = false;
        });
      }, 800);
      return;
    },
    printBox() {
      if (!this.labelDialog) {
        this.labelDialog = true;
      }
      setTimeout(() => {
        this.$htmlToPaper("print-label-area", null, () => {
          this.labelDialog = false;
        });
      }, 800);
      return;
    },
    hideLoading() {
      this.loading.close();
    },
    handleSuccess(resp) {
      if (resp.success) {
        this.order.payment.payment_image_url_admin = resp.data.path;
        this.$notify({
          title: "สำเร็จ",
          message: "อัพโหลดรูปภาพสำเร็จ",
          type: "success",
        });
      }
    },
    downloadPDF() {
      this.showLoading();

      try {
        var data = new FormData();
        data.append("type", "pdf");
        data.append("template", "luicha-01");

        let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
        let accessToken = vuex.Auth.accessToken;

        var request = new XMLHttpRequest();

        request.responseType = "blob";
        request.onreadystatechange = (e) => {
          let _ = this;
          let filename =
            "แบบฟอร์มบิลเก็บค่าวัตถุดิบ ใบเสร็จรับเงินเลขที่ " +
            this.order.order_reference;

          if (request.readyState !== 4) {
            return;
          }
          if (request.status === 200) {
            //console.log("success", request.response);
            var fileURL = window.URL.createObjectURL(
              new Blob([request.response], {
                type: "application/pdf",
              })
            );
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", filename + ".pdf");
            document.body.appendChild(fileLink);

            _.hideLoading();
            fileLink.click();
          } else {
            _.hideLoading();
            console.warn(request);
          }
        };

        request.onload = function(oEvent) {
          var blob = request.response;
        };

        request.onerror = function() {
          _.hideLoading();
        };

        request.open(
          "POST",
          "https://hlzd-delivery-api.halalize.com/orders/" +
            this.order.order_reference +
            "/invoice"
        );
        request.setRequestHeader("Content-Type", "application/json");
        request.setRequestHeader("Authorization", "Bearer " + accessToken);
        //request.setRequestHeader("Accept", "*/*");
        //request.setRequestHeader("Origin", "dev-admin.foodhunt.com");
        //request.setRequestHeader("Host", "dev-order-api.foodhunt.com");
        request.send(data);
      } catch (error) {
        this.hideLoading();
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.driverInterval);
    next();
  },
};
</script>
<style lang="scss">
.promotion {
  font-weight: bold;
  border-radius: 8px;
}

.el-upload-dragger {
  width: 200px !important;
}

@media print {
  @page {
    size: portrait;
  }
}
</style>
